export const TEST_ID = 'batteryCardGrid';
